import React from 'react';
import {ExhibitInformationData} from "types/Exhibit";
import InformationArticle from "pages/Exhibit/Preview/InformationArticle";
import {Disclosure} from "@headlessui/react";

type Props = {
    sections: Array<ExhibitInformationData>
    previewCount: number
}

function InformationList({sections, previewCount}: Props) {
    const previewSections   = sections.slice(0, previewCount)
    const remainingSections = sections.slice(previewCount)
    
    return (
        <>
            <ul>
                {previewSections.map((section, index) => <InformationArticle section={section} key={index}/>)}
            </ul>

            {!!remainingSections.length &&
                <Disclosure>
                    {({open}) => (
                        <>
                            {!open &&
                                <Disclosure.Button className="mt-7 text-brand font-medium">
                                    <span className="underline">View more</span> &gt;
                                </Disclosure.Button>
                            }
                            <Disclosure.Panel>
                                <ul>
                                    {remainingSections.map((section, index) => (<InformationArticle section={section} key={index}/>))}
                                </ul>
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            }
        </>
    );
}

InformationList.defaultProps = {
    previewCount: 1
}

export default InformationList;